import { defineMessages } from 'react-intl';

export const messages: {
	dateLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	timeLabelSuffix: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	timeLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dateTimeLabelSuffix: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	dateLabel: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.date-time-input.preview.date-label',
		defaultMessage: 'Date',
		description: 'Fallback label for the date picker in the date-time input field in preview mode',
	},
	timeLabelSuffix: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.date-time-input.preview.time-label-suffix',
		defaultMessage: '(Date)',
		description: 'Suffix for the date label in the date-time input field in preview mode',
	},
	timeLabel: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.date-time-input.preview.time-label',
		defaultMessage: 'Time',
		description: 'Fallback label for the time picker in the date-time input field in preview mode',
	},
	dateTimeLabelSuffix: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.date-time-input.preview.date-time-label-suffix',
		defaultMessage: '(Time)',
		description: 'Suffix for the time label in the date-time input field in preview mode',
	},
});
